import { filter, map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { SymbolAction } from '@cbridge-packages/symbol';

export const handleCoreSymbolNotFoundEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.load.failed),
  filter(({ error }) => error.status === 404),
  map(() => DetailsSidebarAction.close()),
);
